import { memo } from "react"
import Skeleton from "./base"

const InvoiceSkeleton = () => {
  return (
    <Skeleton>
      <div className="space-y-8">
        {/* Invoice header */}
        <div>
          <div className="h-6 bg-gray-200 rounded w-32 mb-4"></div>
          <div className="h-4 bg-gray-100 rounded w-48"></div>
        </div>

        {/* From/To section */}
        <div className="flex justify-between pt-4">
          <div className="space-y-2">
            <div className="h-3 bg-gray-100 rounded w-24"></div>
            <div className="h-4 bg-gray-200 rounded w-40"></div>
            <div className="h-3 bg-gray-100 rounded w-48"></div>
            <div className="h-3 bg-gray-100 rounded w-36"></div>
            <div className="h-3 bg-gray-100 rounded w-32"></div>
            <div className="h-3 bg-gray-100 rounded w-44"></div>
          </div>
          <div className="space-y-2">
            <div className="h-3 bg-gray-100 rounded w-24"></div>
            <div className="h-4 bg-gray-200 rounded w-48"></div>
          </div>
        </div>

        {/* Subscription level */}
        <div className="border-t border-gray-200 pt-4">
          <div className="h-4 bg-gray-100 rounded w-56 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-40"></div>
        </div>

        {/* Leads table skeleton */}
        <div className="space-y-4">
          <div className="flex justify-between pb-2 border-b border-gray-200">
            <div className="h-3 bg-gray-100 rounded w-20"></div>
            <div className="h-3 bg-gray-100 rounded w-16"></div>
            <div className="h-3 bg-gray-100 rounded w-16"></div>
            <div className="h-3 bg-gray-100 rounded w-24"></div>
          </div>
          {[...Array(3)].map((_, i) => (
            <div key={i} className="flex justify-between py-2">
              <div className="h-4 bg-gray-200 rounded w-32"></div>
              <div className="h-4 bg-gray-100 rounded w-16"></div>
              <div className="h-4 bg-gray-100 rounded w-12"></div>
              <div className="h-4 bg-gray-100 rounded w-20"></div>
            </div>
          ))}
          <div className="flex justify-end pt-2">
            <div className="h-5 bg-gray-200 rounded w-32"></div>
          </div>
        </div>

        {/* Emails table skeleton */}
        <div className="space-y-4 pt-4">
          <div className="h-4 bg-gray-200 rounded w-48 mb-4"></div>
          <div className="flex justify-between pb-2 border-b border-gray-200">
            <div className="h-3 bg-gray-100 rounded w-20"></div>
            <div className="h-3 bg-gray-100 rounded w-16"></div>
            <div className="h-3 bg-gray-100 rounded w-16"></div>
            <div className="h-3 bg-gray-100 rounded w-24"></div>
          </div>
          {[...Array(5)].map((_, i) => (
            <div key={i} className="flex justify-between py-2">
              <div className="h-4 bg-gray-200 rounded w-32"></div>
              <div className="h-4 bg-gray-100 rounded w-16"></div>
              <div className="h-4 bg-gray-100 rounded w-16"></div>
              <div className="h-4 bg-gray-100 rounded w-20"></div>
            </div>
          ))}
          <div className="flex justify-end pt-2">
            <div className="h-5 bg-gray-200 rounded w-32"></div>
          </div>
        </div>

        {/* Total section */}
        <div className="flex justify-between items-center pt-6 border-t-2 border-gray-300">
          <div className="space-y-2">
            <div className="h-4 bg-gray-100 rounded w-28"></div>
            <div className="h-4 bg-gray-100 rounded w-20"></div>
            <div className="h-4 bg-gray-100 rounded w-24"></div>
          </div>
          <div className="bg-gray-200 h-16 w-40 rounded"></div>
        </div>
      </div>
    </Skeleton>
  )
}

export default memo(InvoiceSkeleton)
